import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useGlobalStore } from '@/stores/index'
import api from '@/api'
import { useAbstractPartsStore } from '@/stores/abstract-parts'
import { useTracePartsStore } from '@/stores/tracepart'
import { useMatingPairsStore } from '@/stores/matingPairs'
import {useCableConfiguratorStore} from '@/stores/cableConfigurator';
import {useCartStore} from '@/stores/cart';
import {useRouter} from 'vue-router';

export const usePartStore = defineStore('part', () =>
{
    const partsGlobals = useAbstractPartsStore()

    const detailItem = ref({})

    const crimpTools = ref([])
    const removalTools = ref([])
    const contactItems = ref([])
    const expressAlternatives = ref([])
    const accessories = ref([])
    const mouserObject = ref({})
    const digikeyObject = ref({})

    const cadenasAvailable = ref(false)

    const globals = useGlobalStore()
    const tracepart = useTracePartsStore()
    const matingPair = useMatingPairsStore()
    const cableConfigurationStore = useCableConfiguratorStore()
    const cartStore = useCartStore()
    const router = useRouter()

    const apiUrlGetAssemblyInstructionPath = partsGlobals.apiUrlGetAssemblyInstructionPath
    const apiUrlGetStpFilesPath = partsGlobals.apiUrlGetStpFilesPath
    const imagePath = partsGlobals.imagePath

    const cableConfiguration = ref({})

    const imageSwiper = ref({
        active: 0,
        slides: [
            {
                available: true,
                group: 1,
                id: 'image'
            },
            {
                available: false,
                group: 2,
                id: 'codingDescriptionDrawing'
            },
            {
                available: false,
                group: 2,
                id: 'positionsDrawing'
            },
            {
                available: false,
                group: 2,
                id: 'panelCutOut'
            },
            {
                available: false,
                group: 2,
                id: 'dimensionsDrawing'
            },
            {
                available: false,
                group: 2,
                id: 'Image1PCBLayout'
            },
            {
                available: false,
                group: 2,
                id: 'DrawingCableAssembly'
            },
            {
                available: false,
                group: 3,
                id: 'viewer'
            },
            {
                available: false,
                group: 3,
                id: 'cadenas'
            }
        ]
    })


    async function getItemById (id)
    {
        return new Promise((resolve, reject) =>
        {
            api.get(`${partsGlobals.apiUrlGetParts.value}/${id}`, {params: {'X-LOCALE': globals.locale}}).then(response => {
                resolve(response)
            }).catch(e => {
                reject(e)
            })
        })
    }
    async function getCableConfigurationById (id)
    {
        return new Promise((resolve, reject) =>
        {
            api.get(`${partsGlobals.apiUrlGetCableConfigurations.value}/${id}`, {params: {'X-LOCALE': globals.locale}}).then(response => {
                resolve(response)
            }).catch(e => {
                reject(e)
            })
        })
    }

    async function getRemovalTool ()
    {
        if (detailItem.value.contactCrimpConfiguration && detailItem.value.contactCrimpConfiguration.removalTools && detailItem.value.contactCrimpConfiguration.removalTools.length)
        {
            detailItem.value.contactCrimpConfiguration.removalTools.forEach(element =>
            {
                getItemById(element).then(response =>
                {
                    removalTools.value.push(response.data)
                })
            })
        }

    }

    async function getCrimpTools ()
    {
        if (detailItem.value.contactCrimpConfiguration && detailItem.value.contactCrimpConfiguration.crimpToolOneId)
        {
            getItemById(detailItem.value.contactCrimpConfiguration.crimpToolOneId).then(response =>
            {
                crimpTools.value.push(response.data)
            })
        }
        if (detailItem.value.contactCrimpConfiguration && detailItem.value.contactCrimpConfiguration.crimpToolTwoId)
        {
            getItemById(detailItem.value.contactCrimpConfiguration.crimpToolTwoId).then(response =>
            {
                crimpTools.value.push(response.data)
            })
        }

    }

    async function getExpressAlternatives ()
    {
        if (detailItem.value.expressAlternatives)
        {
            detailItem.value.expressAlternatives.forEach(element =>
            {
                getItemById(element).then(response =>
                {
                    expressAlternatives.value.push(response.data)
                })
            })
        }
    }

    async function getCableConfiguration ()
    {
        cableConfigurationStore.setCableConfigurationValues(detailItem.value.assemblyId, detailItem.value.assemblyNo)
        getCableConfigurationById(detailItem.value.assemblyId).then(response =>
        {
            detailItem.value.cableConfigurationAvailable = true
            cableConfigurationStore.setPredefinedValues(detailItem.value.id, detailItem.value.typeKey, response.data)
            cableConfiguration.value = response.data
            cableConfigurationStore.cableLength = cableConfiguration.value.cableLengthMin
        }).catch()
    }

    async function getAccessories ()
    {
        if (detailItem.value.accessories)
        {
            detailItem.value.accessories.forEach(element =>
            {
                getItemById(element).then(response =>
                {
                    accessories.value.push(response.data)
                })
            })
        }
    }

    async function getMouserAvailability ()
    {
      const settings = {
        'SearchByPartRequest': {
          'mouserPartNumber': detailItem.value.id,
          'partSearchOptions': 'Exact'
        }
      }
      api.post(`https://api.mouser.com/api/v1/search/partnumber?apiKey=${partsGlobals.mouserApiKey}&version=1`, settings).then(response => {
        if (response.data['SearchResults'] && response.data['SearchResults']['NumberOfResult'] > 0)
        {
          mouserObject.value = response.data['SearchResults']
        }
      }).catch(e => {
        console.log(e)
      })
    }

    async function getDigiKeyAvailability ()
    {
      const config = {
          'headers' : {
              'X-DIGIKEY-Client-Id': partsGlobals.digiKeyClientId
          }
      }
      api.get(`https://api.digikey.com/Manufacturer/v1/Stock/${detailItem.value.id}`, config).then(response => {
        if (response.data['ManufacturerStocks'] && response.data['ManufacturerStocks'][0])
        {
          digikeyObject.value = response.data['ManufacturerStocks'][0]
        }
      }).catch(e => {
        console.log(e)
      })
    }

    async function getContactItem ()
    {
        if (detailItem.value.contacts && detailItem.value.contacts.length) {
            detailItem.value.contacts.forEach(element =>
            {
                getItemById(element).then(async response => {
                    let contact = response.data
                    if (contact.contactCrimpConfiguration && contact.contactCrimpConfiguration.crimpToolOneId) {
                        await getItemById(contact.contactCrimpConfiguration.crimpToolOneId).then(res => {
                            contact['crimpToolOne'] = res.data
                        })
                    }
                    if (contact.contactCrimpConfiguration && contact.contactCrimpConfiguration.crimpToolTwoId) {
                        await getItemById(contact.contactCrimpConfiguration.crimpToolTwoId).then(res => {
                            contact['crimpToolTwo'] = res.data
                        })
                    }
                    if (contact.contactCrimpConfiguration && contact.contactCrimpConfiguration.removalTools.length) {
                        contact['removalToolsObjects'] = []
                        for (let i = 0; i < contact.contactCrimpConfiguration.removalTools.length; i++)
                        {
                            await getItemById(contact.contactCrimpConfiguration.removalTools[i]).then(res => {
                                contact['removalToolsObjects'].push(res.data)
                            })
                        }
                    }
                    contactItems.value.push(contact)

                }).catch()
            })
        }
    }

    async function getDetailItem (id)
    {
        await getItemById(id).then(response =>
        {
            detailItem.value = response.data
            globals.loading = false
        }).catch(() =>
        {
            globals.error = true
        })
        Promise.all([
            getRemovalTool(),
            getCrimpTools(),
            getContactItem(),
            getExpressAlternatives(),
            getAccessories(),
            getCableConfiguration(),
            getMouserAvailability(),
            getDigiKeyAvailability(),
            matingPair.getMatingPairs(detailItem.value.matingPair)
        ])
    }

    function addCableToCart (force = false)
    {
        getItemById(cableConfigurationStore.configuredCableConfigurationIdWithoutLength).then(response =>
        {
            let el = response.data
            if (force)
            {
              el.cableConfigLength = cableConfigurationStore.cableLength
              el.cableConfigBend = cableConfigurationStore.bendOption.label
              el.cableConfigCountNo = cableConfigurationStore.countNoOption.label
              cartStore.addToCart(el)
              router.push({
                  name: 'Detail',
                  params:  {id: el.id},
                  query: {cableLength: cableConfigurationStore.cableLength}
              })
              cartStore.cableInCartHint = false
              cartStore.savedCableConfigHint = true
            } else
            {
                if (!cartStore.itemInCart(el))
                {
                  el.cableConfigLength = cableConfigurationStore.cableLength
                  el.cableConfigBend = cableConfigurationStore.bendOption.label
                  el.cableConfigCountNo = cableConfigurationStore.countNoOption.label
                  cartStore.addToCart(el)
                    router.push({
                        name: 'Detail',
                        params:  {id: el.id},
                        query: {cableLength: cableConfigurationStore.cableLength}
                    })
                  detailItem.value.cableConfigLength = cableConfigurationStore.cableLength
                  cartStore.savedCableConfigHint = true
                }
                else {
                  cartStore.cableInCartHint = true
                }
            }

        }).catch(() => {})
    }

    function clearDetailItem ()
    {
        detailItem.value = {}
        crimpTools.value = []
        removalTools.value = []
        contactItems.value = []
        expressAlternatives.value = []
        accessories.value = []
        cableConfiguration.value = {}
        mouserObject.value = {}
        digikeyObject.value = {}
        imageSwiper.value = {
            active: 0,
            slides: [
                {
                    available: true,
                    group: 1,
                    id: 'image'
                },
                {
                    available: false,
                    group: 2,
                    id: 'codingDescriptionDrawing'
                },
                {
                    available: false,
                    group: 2,
                    id: 'positionsDrawing'
                },
                {
                    available: false,
                    group: 2,
                    id: 'panelCutOut'
                },
                {
                    available: false,
                    group: 2,
                    id: 'dimensionsDrawing'
                },
                {
                    available: false,
                    group: 2,
                    id: 'Image1PCBLayout'
                },
                {
                    available: false,
                    group: 2,
                    id: 'DrawingCableAssembly'
                },
                {
                    available: false,
                    group: 3,
                    id: 'viewer'
                },
                {
                    available: true,
                    group: 3,
                    id: 'cadenas'
                }
            ]
        }
        tracepart.clearItem()
        matingPair.clearItem()
        cableConfigurationStore.clearConfiguration()
        cartStore.overlay = false
    }

    function initImageSwiper ()
    {

        if (detailItem.value.codingDescriptionDrawing)
        {
            imageSwiper.value.slides[1].available = true
        }
        if (detailItem.value.positionsDrawing)
        {
            imageSwiper.value.slides[2].available = true
        }
        if (detailItem.value.panelCutOut)
        {
            imageSwiper.value.slides[3].available = true
        }
        if (detailItem.value.dimensionsDrawing)
        {
            imageSwiper.value.slides[4].available = true
        }
        if (detailItem.value.Image1PCBLayout)
        {
            imageSwiper.value.slides[5].available = true
        }
        if (detailItem.value.drawingCableAssembly)
        {
            imageSwiper.value.slides[6].available = true
        }
    }

    function initImageSwiperViewer ()
    {
        if (tracepart.cadInformation.viewer3dAvailable)
        {
            imageSwiper.value.slides[7].available = true
        }
        globals.lazyLoading = false
    }

    return {
        detailItem,
        clearDetailItem,
        getItemById,
        apiUrlGetAssemblyInstructionPath,
        apiUrlGetStpFilesPath,
        imagePath,
        imageSwiper,
        crimpTools,
        removalTools,
        contactItems,
        expressAlternatives,
        accessories,
        initImageSwiper,
        initImageSwiperViewer,
        getDetailItem,
        addCableToCart,
        cableConfiguration,
        cadenasAvailable,
        mouserObject,
        digikeyObject
    }
})
